import React from 'react';
import { store } from '../../../../store'

const Controller = ({onOpen, onSelectToolbar}) => {

if(store.getState().activities.edit) {
  return (
    <div className="controller_outer">
    <span className={
    store.getState().customization.select === 'profile'
    ? 'controller controller_active controller_profile'
    : 'controller controller_profile'
    }
    onClick={()=>{
      onOpen('toolbar')
      onSelectToolbar('profile')
    }}
    ><i class="fa fa-user-o controller_icon"></i></span>
    <span className={
    store.getState().customization.select === 'background'
    ? 'controller controller_active controller_background'
    : 'controller controller_background'
    }
    onClick={()=>{
      onOpen('toolbar')
      onSelectToolbar('background')
    }}
    ><i class="fa fa-paint-brush controller_icon"></i></span>
    <span className={
    store.getState().customization.select === 'about'
    ? 'controller controller_active controller_about'
    : 'controller controller_about'
    }
    onClick={()=>{
      onOpen('toolbar')
      onSelectToolbar('about')
    }}
    ><i class="fa fa-pencil-square-o controller_icon"></i></span>
    </div>
    )
  }
  else return null
}
export default Controller